import { useState, useEffect } from 'react'

export const useOfflineDetection = () => {
  const [isOffline, setIsOffline] = useState(!navigator.onLine)
  const [isHotspotMode, setIsHotspotMode] = useState(false)

  useEffect(() => {
    const handleOnline = () => {
      setIsOffline(false)
      console.log('🌐 Back online')
    }

    const handleOffline = () => {
      setIsOffline(true)
      console.log('📶 Gone offline')
    }

    // Check if we're in hotspot mode (connected to NodeMCU AP)
    const checkHotspotMode = async () => {
      try {
        // Try to connect to NodeMCU hotspot IP
        const response = await fetch('http://192.168.4.1/status', {
          method: 'GET',
          mode: 'no-cors',
          timeout: 2000
        })
        setIsHotspotMode(true)
        console.log('📡 Hotspot mode detected')
      } catch (error) {
        setIsHotspotMode(false)
        console.log('🌐 Router mode detected')
      }
    }

    // Listen for online/offline events
    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    // Check hotspot mode on mount
    checkHotspotMode()

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  // Get hotspot connection instructions
  const getHotspotInstructions = () => ({
    ssid: 'EZ_Control_AP',
    password: '12345678',
    ip: '192.168.4.1',
    url: 'http://192.168.4.1'
  })

  // Check if we can access NodeMCU directly
  const checkNodeMCUAccess = async (ip = '192.168.4.1') => {
    try {
      const response = await fetch(`http://${ip}/status`, {
        method: 'GET',
        mode: 'no-cors',
        timeout: 3000
      })
      return true
    } catch (error) {
      return false
    }
  }

  return {
    isOffline,
    isHotspotMode,
    getHotspotInstructions,
    checkNodeMCUAccess
  }
}
